const slider = document.querySelector(".carrusel-container");
let isDown = false;
let startX;
let scrollLeft;

slider.addEventListener("mousedown", (e) => {
  isDown = true;
  slider.classList.add("active");
  startX = e.pageX - slider.offsetLeft;
  scrollLeft = slider.scrollLeft;
});

slider.addEventListener("mouseleave", () => {
  isDown = false;
  slider.classList.remove("active");
});

slider.addEventListener("mouseup", () => {
  isDown = false;
  slider.classList.remove("active");
});

slider.addEventListener("mousemove", (e) => {
  if (!isDown) return;
  e.preventDefault();
  const x = e.pageX - slider.offsetLeft;
  const walk = (x - startX) * 2; //scroll-fast
  slider.scrollLeft = scrollLeft - walk;
});

// Change maxWidth
function ajustarMaxWidth() {
  var sliderContainer = document.getElementById("blogSliderContainer");
  if (!sliderContainer) {
    console.log("Slider container not found!");
    return;
  }

  sliderContainer.style.removeProperty("max-width");
  sliderContainer.style.removeProperty("margin-right");

  var containerStyles = window.getComputedStyle(sliderContainer);
  var widthActual = parseInt(containerStyles.width, 10);
  var marginRight = parseInt(containerStyles.marginRight, 10);
  var nuevoWidth = widthActual + marginRight;

  sliderContainer.style.maxWidth = nuevoWidth + "px";
  sliderContainer.style.marginRight = "0px"; // Esto es equivalente a 0 + "px"
}

function debounce(func, wait, immediate) {
  var timeout;
  return function () {
    var context = this,
      args = arguments;
    var later = function () {
      timeout = null;
      if (!immediate) func.apply(context, args);
    };
    var callNow = immediate && !timeout;
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
    if (callNow) func.apply(context, args);
  };
}

function handleResize() {
  this.ajustarMaxWidth();
}

window.addEventListener("load", ajustarMaxWidth);
window.addEventListener("resize", debounce(handleResize, 500));
